export default __webpack_public_path__ + "static/media/cross.8295e508.svg";